import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
	Box,
	Button,
	CircularProgress,
	IconButton,
	Tab,
	Tabs,
	Tooltip,
	Typography
} from "@mui/material";
import { observer } from "mobx-react";
import { SchoolLevelSubjects } from "@common/SchoolLevelSubjects";
import { ReactComponent as PageUpIcon } from '@common/images/PageUpIcon.svg';
// import { withRouter } from "../../../../components/WithRouter";
import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { ProjectPreviewStyle } from "@styles/projects/ProjectPreviewStyle";



import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStores } from '@hooks/useStores';
import { ProjectSchoolType } from '@stores/enums/ProjectStoreEnums';
import { AnswerTab } from '@views/shared/tabs/AnswerTab';
import { QuestionAndReferenceTab } from '@views/shared/tabs/QuestionAndReferenceTab';
import { RubricTab } from '@views/shared/tabs/RubricTab';
import { useParams } from 'react-router-dom';
import { codeUtil } from '@util/codeUtil';
import { IProjectPropertyReader } from '@repositories/model/IProject';

type Props = {
}

function ProjectPreviewRightPannel(props: Props) {
	const params = useParams();
	const classes = useEmotionStyles( ProjectPreviewStyle );
	const [tabIndex, setTabIndex] = React.useState(0);
	const [projectCode, setProjectCode] = React.useState("");
	const [open, setOpen] = React.useState(window.innerWidth > 1500);
	const [tooltipOpen, setTooltipOpen] = React.useState(false);
	const [isSelectingAll, setIsSelectingAll] = React.useState(false);
	const [isChangingTab, setIsChangingTab] = React.useState(false);
	const [didMount, setDidMount] = React.useState(true);

	const { navigateStore, projectStore, projectRagStore, projectExamStore, projectRubricStore } = useStores();
	const { project } = projectStore;
	const {
		projectExamQuestionsList,
		questionListLenObjPerExam,
		projectRubricTransferList,
		questionKeyAndSelectedProjectRubricIdxMap,
	} = projectRubricStore;

	const basicInfoRef = React.useRef(null);
	const questionRef = React.useRef(null);
	const goodAnswerRef = React.useRef(null);
	const rubricRef = React.useRef(null);

	let scrolloingTimeOut;

	React.useEffect(() => {
		const currentProjectCode = params?.projectCode;
		if (!currentProjectCode || currentProjectCode === projectCode) return;

		setProjectCode(currentProjectCode);
	}, [params]);

	React.useEffect(() => {
		setOpenByLocalStorage();

		return () => {
			clearTimeout(scrolloingTimeOut);
		};
	}, []);

	const setOpenByLocalStorage = () => {
		const isOpen = localStorage.getItem('previewState');
		if (isOpen === undefined || isOpen === null) {
			setOpen(window.innerWidth > 1500);
		} else {
			if (isOpen === 'true') {
				setOpen(true);
			} else if (isOpen === 'false') {
				setOpen(false);
			}
		}
	};

	const setTabIndexBySideBarStepNum = (sideBarStepNum) => {
		let tabIndex = 0;
		if (sideBarStepNum === 2 || sideBarStepNum === 3) tabIndex = 1;
		if (sideBarStepNum === 4) tabIndex = 2;
		if (sideBarStepNum === 5) tabIndex = 3;

		return tabIndex;
	};

	React.useEffect(() => {
		const sideBarStepNum = navigateStore.sideBarMakeProjectStepNum;
		if (!projectCode || sideBarStepNum === undefined) return;

		// 현재 페이지는 실시간 적용되도록 제외

		// 평가 계획
		if (sideBarStepNum !== 1) {
			projectStore.downloadProjectInfoAndStore(projectCode);
		}

		if (sideBarStepNum !== 2 && sideBarStepNum !== 4) {
			// 문항 생성 or 모범 답안
			projectExamStore.downloadProjectExamListAndStore(projectCode);
		}

		if (sideBarStepNum !== 3) {
			// 평가 참고 자료
			projectRagStore.getProjectRag(projectCode);
		}

		if (sideBarStepNum !== 5) {
			// 평가 기준표
			projectRubricStore.getProjectExamQuestions(projectCode);
		}

		setIsSelectingAll(true);

		const tabIndex = setTabIndexBySideBarStepNum(sideBarStepNum);
		setTabIndex(tabIndex);

		return () => {
			projectStore.init();
			projectExamStore.init();
			projectRagStore.init();
			projectRubricStore.init();
		}
	}, [projectCode, navigateStore.navigateDetailPage, navigateStore.sideBarMakeProjectStepNum]);

	React.useEffect(() => {
		if (!isSelectingAll) return;

		if (
			!projectStore.isSelectingProjectInfo &&
			!projectExamStore.isSelectingProjectExamList &&
			!projectRagStore.isSelectingProjectRag &&
			!projectRubricStore.isSelectingProjectExamQuestions
		) {
			setIsSelectingAll(false);
			setIsChangingTab(true);
		}

	}, [
		isSelectingAll,
		projectStore.isSelectingProjectInfo,
		projectExamStore.isSelectingProjectExamList,
		projectRagStore.isSelectingProjectRag,
		projectRubricStore.isSelectingProjectExamQuestions,
	]);

	React.useEffect(() => {
		if (!isChangingTab || !open) return;

		setIsChangingTab(false);
		setDidMount(false);

		const setTimeOutForTab = setTimeout(() => {
			handleChangeTab(null, true, tabIndex);
			clearTimeout(setTimeOutForTab);
		}, 50)
	}, [isChangingTab, open, tabIndex]);

	React.useEffect(() => {
		if (didMount || !open) return;

		const tabIndex = setTabIndexBySideBarStepNum(navigateStore.sideBarMakeProjectStepNum);

		handleChangeTab(null, true, tabIndex);
	}, [open]);

	const handleChangeTab = (event, isMounted, newIndex) => {
		let selectedTag;

		switch (newIndex) {
			case 0:
				if (basicInfoRef?.current) {
					selectedTag = basicInfoRef.current;
				}
				break;
			case 1:
				if (questionRef?.current) {
					selectedTag = questionRef.current;
				}
				break;
			case 2:
				if (goodAnswerRef?.current) {
					selectedTag = goodAnswerRef.current;
				}
				break;
			case 3:
				if (rubricRef?.current) {
					selectedTag = rubricRef.current;
				}
				break;
		}

		setTabIndex(newIndex);

		if (!selectedTag) return;

		if (!isMounted) {
			selectedTag.scrollIntoView({ behavior: 'smooth' });
			return;
		}

		scrolloingTimeOut = setTimeout(() => {
			selectedTag.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}, 500);
	};

	const handleClickScrollToTopBtn = () => {
		if (basicInfoRef.current) {
			basicInfoRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	};

	const handleClickOpenBtn = () => {
		localStorage.setItem('previewState', `${!open}`);
		setOpen(!open);
		setTooltipOpen(false)
	};

	const currentSchoolLevelObj = React.useMemo(() => {
		return SchoolLevelSubjects.find(school => school.name === project?.schoolType);
	}, [project]);

	const currentSubjectGroupObj = React.useMemo(() => {
		if (!currentSchoolLevelObj) return;

		return currentSchoolLevelObj.subjectGroups.find(group => group.name === project?.subject);
	}, [project, currentSchoolLevelObj]);

	const currentSubjectObj = React.useMemo(() => {
		if (!currentSubjectGroupObj) return;

		return currentSubjectGroupObj.subjects.find(subject => subject.name === project?.subjectName);
	}, [project, currentSubjectGroupObj]);

	const i18next = useTranslation();

	const renderSchoolGradeSubjectBox = () => {
		
				let grade: string = "";
				let schoolType: ProjectSchoolType = ProjectSchoolType.NOGRADE;
				let subject: string = "";
				let subjectRange: string = "";
				let secondRowText: string = "";
				let firstRowText: string = "";
				let thirdRowText: string = "";
				let fourthRowText: string = "";
				let fifthRowText: string = "";
		
				// 2025.09.09
				if (IProjectPropertyReader.isBefore027Ver(project)) {
					const values = IProjectPropertyReader.before027VerCurriculumInfo(project);
					schoolType = values[0];
					grade = values[1];
					subject = values[2];
					subjectRange = values[3];
		
					const result = codeUtil.mappedGradeStringAndSchoolString(grade);
					const subjectText: string = subject;
		
					let subjectTranslatedText = codeUtil.translatedSubjectName(subjectText);
					secondRowText = `${result[0]} / ${subjectTranslatedText} / ${subjectRange ?? '-'}`;
					firstRowText = result[1];
					thirdRowText = "-";
					fourthRowText = "-";
					fifthRowText = "-";
		
				} else {
					const values = IProjectPropertyReader.after027VerCurriculumInfo(project);
					secondRowText = `${values[1]} / ${values[2]} / ${values[3] ?? '-'}`;
					firstRowText = `${values[0]}`;
					thirdRowText = values[4];
					fourthRowText = `[${values[5]}]`;
					fifthRowText = values[6];
				}
				
				console.log("📗 Grade/Subject:", secondRowText);
			
				return (
					<div>
						<Box className={classes.displayStyle}>
							<Typography className={classes.basicTitle2}>{i18next.t('학교급')}</Typography>
							<Typography className={classes.basicText2}>{firstRowText}</Typography>
						</Box>
						<Box className={classes.displayStyle}>
							<Typography className={classes.basicTitle2}>{i18next.t('학년/교과/과목')}</Typography>
							<Typography className={classes.basicText2}>{secondRowText}</Typography>
						</Box>
						<Box className={classes.displayStyle}>
							<Typography className={classes.basicTitle2}>{i18next.t('영역(단원)')}</Typography>
							<Typography className={classes.basicText2}>{thirdRowText}</Typography>
						</Box>
						<Box className={classes.displayStyle}>
							<Typography className={classes.basicTitle2}>{i18next.t('성취기준코드')}</Typography>
							<Typography className={classes.basicText2}>{fourthRowText}</Typography>
						</Box>
						<Box className={classes.displayStyle}>
							<Typography className={classes.basicTitle2}>{i18next.t('성취기준명')}</Typography>
							<Typography className={classes.basicText2}>{fifthRowText}</Typography>
						</Box>
					</div>
				);
			};
			

	return (
		<Box className={classes.previewRoot}>
			<Box className={open ? classes.openFoldBtnBox : classes.closedFoldBtnBox}>
				<Tooltip title={open ? i18next.t('접기') : i18next.t('펼치기')}
					open={tooltipOpen}
					classes={{ tooltip: classes.contentTooltip }}
					placement="bottom">
					<Button className={classes.foldBtn}
						onClick={handleClickOpenBtn}
						onMouseEnter={() => setTooltipOpen(true)}
						onMouseLeave={() => setTooltipOpen(false)}
						disableRipple>
						{open ?
							<ArrowForwardIosIcon /> :
							<ArrowBackIosNewIcon />
						}
					</Button>
				</Tooltip>
			</Box>
			{open &&
				<Box className={classes.mainContentBoxRight}>
					{(!didMount && !isSelectingAll) ?
						<Box>
							<Typography className={classes.previewText}>{i18next.t('미리보기')}</Typography>
							<Typography className={classes.previewSubText}>{i18next.t('과제 개요부터 입력한 내용을 한눈에 바로 확인할 수 있습니다.')}</Typography>
							<Tabs value={tabIndex} onChange={(e, newIdx) => handleChangeTab(e, false, newIdx)} className={classes.trigger}>
								<Tab value={0} label={i18next.t('과제 개요')} disableRipple />
								<Tab value={1} label={i18next.t('문항')} disableRipple />
								<Tab value={2} label={i18next.t('모범 답안')} disableRipple />
								<Tab value={3} label={i18next.t('평가 기준표')} disableRipple />
							</Tabs>

							<div className={classes.root}>
								<Box className={classes.scrollBox} style={{ paddingRight: 20 }}>

									<Box>
										<Box className={classes.commonSubTitleBasicBox} >
											<Typography className={classes.commonSubTitle} ref={basicInfoRef}>{i18next.t('과제 개요')}</Typography>
										</Box>

										<Box className={classes.listBoxTop}>
											
											{renderSchoolGradeSubjectBox()}
										</Box>
									</Box>

									<Typography ref={questionRef} className={classes.commonSubTitle}>{i18next.t('문항')}</Typography>
									<QuestionAndReferenceTab
										projectExamList={projectExamStore.projectExamList}

										// projectRagList={projectRagStore.projectRagList}
										sideBarStepNum={navigateStore.sideBarMakeProjectStepNum}
										onClickScrollToTopBtn={handleClickScrollToTopBtn}
										questionRef={questionRef}
										handleClickQuestionEdit={() => { }}
										handleClickRagEdit={() => { }}
										isQuestionNumberLabelVisible={true}
									/>

									<Typography ref={goodAnswerRef} className={classes.commonSubTitle}>{i18next.t('모범 답안')}</Typography>
									<AnswerTab projectExamList={projectExamStore.projectExamList} />
									<Typography ref={rubricRef} className={classes.commonSubTitle}>{i18next.t('평가 기준표')}</Typography>
									<RubricTab
										projectExamQuestionsList={projectExamQuestionsList}
										questionListLenObjPerExam={questionListLenObjPerExam}
										projectRubricTransferList={projectRubricTransferList}
										questionKeyAndSelectedProjectRubricIdxMap={questionKeyAndSelectedProjectRubricIdxMap}
										
									/>
								</Box>
							</div>
						</Box> :
						<Box className={classes.progressBox}>
							<CircularProgress className={classes.progress} />
						</Box>
					}

					<IconButton
						className={classes.pageUpIcon}
						onClick={handleClickScrollToTopBtn}
						disableRipple>
						<PageUpIcon />
					</IconButton>
				</Box>
			}
		</Box>
	);
}


export default observer<typeof ProjectPreviewRightPannel>(ProjectPreviewRightPannel);













